import ProductCategoryUpdate from './ProductCategoryUpdate'
export {ProductCategoryUpdate}
export default ProductCategoryUpdate
